







































import Vue from 'vue'
import UIJsonPrettyView from '../UIComponents/UIJsonPrettyView.vue'

export default Vue.extend({
  components: { UIJsonPrettyView },
  name: 'ChangeModal',
  props: {
    data: Object,
    metaData: Object,
    title: {
      type: String,
      default: 'Added / Updated Fields',
    },
    isDebug: {
      type: Boolean,
      default: false,
    },
  },
})
